import $ from 'jquery';

export const activate = () => {
  const $form = $('form.activation-form');
  const $button = $form.find('button[type="submit"]');
  const $rgpd = $form.find('input[name="rgpd"]');

  $rgpd.closest('.checkbox').checkbox({
    onChecked: () => $button.removeClass('disabled'),
    onUnchecked: () => $button.addClass('disabled'),
  });
};



// WEBPACK FOOTER //
// ./src/modules/account/index.js